import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import { Row, Col, Label, FormGroup, Switch } from 'twyne-new.ui';

import CustomFields from 'components/custom_fields/CustomFields';
import offerStore from 'modules/offer/stores/offer';

const propTypes = {
  override: PropTypes.bool,
  attributes: PropTypes.object,
  onChange: PropTypes.func,
  offerId: PropTypes.number,
};

export default function OverrideAttributes({ override, attributes, onChange, offerId }) {
  const [overrideAttributes, setOverrideAttributes] = useState(false)
  const [offerAttributes, setOfferAttributes] = useState(null)
  const [custom, setCustom] = useState({})

  useEffect(() => {
    override && setOverrideAttributes(override)
  }, [override])

  useEffect(() => {
    attributes && setCustom({ ...attributes })
  }, [attributes])

  useEffect(() => {
    if (overrideAttributes && !offerAttributes) {
      getAttributes().then(attr => setOfferAttributes(attr))
    } else
      if (!overrideAttributes && offerAttributes) {
        setOfferAttributes(null)
      }
    onChange({ override_attributes: overrideAttributes })
  }, [overrideAttributes, offerAttributes])

  const getAttributes = useCallback(async () => {
    let attr = []
    if (!offerId) return attr
    const offer = await offerStore.fetch(offerId, true).then(res => res.data)
    const attributes = offer.custom || []
    attr = attributes.map(item => {
      const attribute = {}
      attribute[item.key] = { name: item.label, type: item.type, options: item.options, defaultValue: item.defaultValue, col_size: item.col_size }
      return attribute
    })
    return attr
  }, [offerId])

  const handleChangeOverride = e => {
    const value = e.target.checked
    if (value === false) {
      onChange({ custom: null })
    } else {
      onChange({ custom })
    }
    setOverrideAttributes(value)
  }

  const handleCustomChange = useCallback((key, value) => {
    const obj = {}
    obj[key] = value || ''

    Object.assign(custom, obj);

    onChange({ custom });
  }, [custom])

  return <>
    <FormGroup>
      <Label>Override Attributes</Label>
      <Switch name="override_attributes" value={overrideAttributes} onChange={handleChangeOverride} />
    </FormGroup>
    <Row key='attributes'>
      {overrideAttributes && offerAttributes && offerAttributes.map((item, index) => <Col size={6} key={index}>
        <CustomFields
          config={item}
          onChange={handleCustomChange}
          custom={custom}
        />
      </Col>)}
    </Row>
  </>
}

OverrideAttributes.propTypes = propTypes
OverrideAttributes.defaultProps = {}
